export const HERO_NAME_INVALID_ERROR_NAME = 'heroNameInvalid';
